module.exports = __webpack_public_path__ + "static/media/loading-gif.ac6fd30e.gif";